import { z } from 'zod';
import { bindWebAuthnGuard } from '../interactions.js';
import { VerificationType } from './verification-type.js';
const baseWebAuthnVerificationRecordDataGuard = z.object({
    id: z.string(),
    verified: z.boolean(),
    registrationChallenge: z.string().optional(),
    registrationRpId: z.string().optional(),
    authenticationChallenge: z.string().optional(),
    registrationInfo: bindWebAuthnGuard.optional(),
});
export const webAuthnVerificationRecordDataGuard = baseWebAuthnVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.WebAuthn),
    userId: z.string(),
});
export const sanitizedWebAuthnVerificationRecordDataGuard = webAuthnVerificationRecordDataGuard.omit({
    registrationInfo: true,
    registrationChallenge: true,
    registrationRpId: true,
    authenticationChallenge: true,
});
export const signInPasskeyVerificationRecordDataGuard = baseWebAuthnVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.SignInPasskey),
    userId: z.string().optional(),
    authenticationRpId: z.string().optional(),
});
export const sanitizedSignInPasskeyVerificationRecordDataGuard = signInPasskeyVerificationRecordDataGuard.omit({
    registrationInfo: true,
    registrationChallenge: true,
    registrationRpId: true,
    authenticationChallenge: true,
    authenticationRpId: true,
});
